import React from 'react';
import { FadeIn } from './FadeIn';

export default function Footer() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-deep-charcoal text-vintage-white pt-16 pb-12 px-6 text-center">
      <div className="max-w-3xl mx-auto">
        <FadeIn>
          <h2 className="text-3xl md:text-5xl font-medium leading-tight mb-8 text-balance">
            Your wedding deserves to be experienced before it is imagined.
          </h2>
          <p className="text-lg font-light text-aged-ivory/70 mb-10 max-w-2xl mx-auto leading-relaxed">
            Schedule your private tour today and see how the heritage of Padua can frame your unique celebration.
          </p>
          <button 
            onClick={scrollToBooking} 
            className="bg-vintage-white text-deep-charcoal px-10 py-5 uppercase tracking-[0.2em] text-xs font-bold hover:bg-aged-ivory transition-all duration-300 active:scale-95"
          >
            Book Your Private Tour
          </button>
        </FadeIn>
        
        <FadeIn delay={0.3} className="mt-16 pt-8 border-t border-vintage-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-[10px] tracking-widest uppercase font-bold text-vintage-white/30">
          <p>© {new Date().getFullYear()} Padua Weddings</p>
          <p>The Setting for Timeless Stories</p>
        </FadeIn>
      </div>
    </footer>
  );
}